import { useMemo } from 'react';

import type { SiteDTO } from '@hotjar/site';
import type { Plan } from '@hotjar/webapp/domains/revenue/plan/types';

import { usePlanRepository } from './usePlanRepository';

interface SitePlans {
  plan: Plan;
  effectivePlan: Plan;
  interimPlan: Plan | null;
}

export function useSitePlans(site: SiteDTO): SitePlans {
  const planRepository = usePlanRepository();

  return useMemo(() => {
    return {
      plan: planRepository.byId(site.plan_id),
      effectivePlan: planRepository.byId(site.effective_plan_id),
      interimPlan: site.interim_plan_id ? planRepository.byId(site.interim_plan_id) : null,
    };
  }, [site, planRepository]);
}
